export interface TripResourceUnit {
  id: string
  licensePlate: string | null
  unitNumber: number | null
  unitTypeCode: string
}

export interface HistoricalTripResource {
  id: string | null
  licensePlate: string | null
  unitNumber: number | null
}

export interface TripResourceOption {
  value: string
  label: string
  sublabel?: string | undefined
}

export function buildTripResourceOptions(
  units: TripResourceUnit[],
  allowedTypeCodes: readonly string[],
  emptyLabel: string,
  historicalResource: HistoricalTripResource | null,
  historicalLabel: string,
): TripResourceOption[] {
  const options = units
    .filter(unit => allowedTypeCodes.includes(unit.unitTypeCode))
    .map(unit => ({
      value: unit.id,
      label: unit.licensePlate ?? `Unidad ${unit.unitNumber ?? "—"}`,
      sublabel: unit.unitNumber != null ? `#${unit.unitNumber}` : undefined,
    }))

  if (historicalResource?.id && !options.some(option => option.value === historicalResource.id)) {
    options.push({
      value: historicalResource.id,
      label: historicalResource.licensePlate ?? historicalLabel,
      sublabel: historicalResource.unitNumber != null ? `#${historicalResource.unitNumber}` : undefined,
    })
  }

  return [{ value: "__none__", label: emptyLabel }, ...options]
}
